import React, { useEffect, useRef, useState } from 'react';
import { StyledHeroShelfzone } from './StyledHeroShelfzone';

const HeroShelfzone = ({loaded}) => {
  const slidesInterval = useRef(null)
  const [currentSlide, setCurrentSlide] = useState(0)
  const [slides, setSlides] = useState([])

  const timer = () => {
    
    slidesInterval.current = setTimeout(() => {
              setCurrentSlide(currentSlide + 1 > 2 ? 0 : currentSlide + 1)
            }, 5000)
  }

  const bulletTimeout = (index) => {
    
    clearTimeout(slidesInterval.current)
    setCurrentSlide(index)
  }
  useEffect(() => {

    if(slides.length > 0){
      let current = document.querySelector('.single-slide--shelfzone.current')
      let bullets = document.querySelectorAll('.bullet-circle')
      let bulletActive = document.querySelector('.bullet-circle.active')


      if(current) current.classList.remove('current')
      slides[currentSlide].classList.add('current')

      if(bulletActive) bulletActive.classList.remove('active')
      bullets[currentSlide].classList.add('active')

      timer()

    }
    
  },[currentSlide,slides])

  useEffect(() => {
    
    if(!loaded.isLoading && slides.length <= 0){
      setSlides(document.querySelectorAll('.single-slide--shelfzone'));
    }
    
  }, [loaded])
  return (
    <React.Fragment>
      {
       
          <StyledHeroShelfzone>
            <div className="slides--shelfzone">
              <div className="slides--content">
                <div className="single-slide--shelfzone">
                  <div className="col-shelfzone col-text--shelfzone">
                    <img src={require('../../assets/logo-shelfzone.png')} />
                    <h4 className="md--title">Build beyond boundaries and expectations</h4>
                  </div>
                  <div className="col-shelfzone col-img--shelfzone">
                    <img src={require('../../assets/shelfzone-slider/slide-1.jpg')} />
                  </div>
                </div>
                <div className="single-slide--shelfzone">
                  <div className="col-shelfzone col-text--shelfzone">
                    <img src={require('../../assets/logo-shelfzone.png')} />
                    <h4 className="md--title">Test the limits of your industry</h4>
                  </div>
                  <div className="col-shelfzone col-img--shelfzone">
                    <img src={require('../../assets/shelfzone-slider/slide-2.jpg')} />
                  </div>
                </div>
                <div className="single-slide--shelfzone">
                  <div className="col-shelfzone col-text--shelfzone">
                    <img src={require('../../assets/logo-shelfzone.png')} />
                    <h4 className="md--title">Showcase your business in a whole new way</h4>
                    <p className="preset-9">All with one powerful power tool</p>
                  </div>
                  <div className="col-shelfzone col-img--shelfzone">
                    <img src={require('../../assets/shelfzone-slider/slide-3.jpg')} />
                  </div>
                </div>
              </div>
              
              <div className="bullets-wrap--slider">
                <div className="bullet-circle active cursor-cta" onClick={() => bulletTimeout(0)}></div>
                <div className="bullet-circle cursor-cta" onClick={() => bulletTimeout(1)}></div>
                <div className="bullet-circle cursor-cta" onClick={() => bulletTimeout(2)}></div>
              </div>
            </div>
            
          </StyledHeroShelfzone>
          
      }
    </React.Fragment>
  );
};



export default HeroShelfzone;
